/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Banner close icon (18px).
 * Used in student temp access warning/alert banners — styled with closeIcon on closeButton.
 *
 * @file BannerCloseIcon.jsx
 * @author Anuja Gaikwad
 * @since 2.3.4
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

function BannerCloseIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.71967 4.21967C5.01256 3.92678 5.48744 3.92678 5.78033 4.21967L9 7.43934L12.2197 4.21967C12.5126 3.92678 12.9874 3.92678 13.2803 4.21967C13.5732 4.51256 13.5732 4.98744 13.2803 5.28033L10.0607 8.5L13.2803 11.7197C13.5732 12.0126 13.5732 12.4874 13.2803 12.7803C12.9874 13.0732 12.5126 13.0732 12.2197 12.7803L9 9.56066L5.78033 12.7803C5.48744 13.0732 5.01256 13.0732 4.71967 12.7803C4.42678 12.4874 4.42678 12.0126 4.71967 11.7197L7.93934 8.5L4.71967 5.28033C4.42678 4.98744 4.42678 4.51256 4.71967 4.21967Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default BannerCloseIcon;
